import React, {
  useEffect,
  useState
}                           from 'react';
import { toast }            from 'react-toastify';
import moment               from 'moment';
import Request              from '~/providers/Request';
import csvGenerator         from '~/utils/csvGenerator';
import PaperView            from '~/components/Paper';
import StatusBilling        from './utils/StatusBilling';
import SupervisedUserCircle from '@material-ui/icons/SupervisedUserCircle';
import { makeStyles }       from '@material-ui/core/styles';
import Table                from '@material-ui/core/Table';
import TableBody            from '@material-ui/core/TableBody';
import TableCell            from '@material-ui/core/TableCell';
import TableContainer       from '@material-ui/core/TableContainer';
import TableHead            from '@material-ui/core/TableHead';
import TableRow             from '@material-ui/core/TableRow';
import Paper                from '@material-ui/core/Paper';

import { appName } from '../../config/uri';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const TypeName = {
  users:     'Adicional de Usuários',
  emergency: 'Botão de Pânico',
  driving:   'Direção Inteligente',
  doctor:    `${appName} Médico`,
};

const StatusName = {
  canceled:     'Cancelado',
  approved:     'Aprovado',
  processing:   'Processando',
};

function PartnersDashboardsList() {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [dataInit, setDataInit] = useState(moment().startOf('month').format());
  const [dataEnd, setDataEnd] = useState(moment().endOf('month').format());
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Request.get('/partner/partners', {
      status: status,
      start: dataInit,
      end: dataEnd
    }).then((value) => {
      setLoading(false);
      setData(value.data);
    });
  }, [status, dataInit, dataEnd]);

  function generateCSV() {
    toast.info('Arquivo CSV esta sendo gerado!');

    Request.get('/partner/partners', {status: status, start: dataInit, end: dataEnd})
      .then(response => {
        const dateFormat = date => date && moment(date).format('DD/MM/YYYY HH:mm:ss');
        const headers = ['ID', 'Usuário', 'Email', 'Telefone', 'Tipo de adicional', 'Licenças', 'Status', 'Data da transação'];
        const rows = response.data.map(pack_bill => {
          const transactionAt = dateFormat(pack_bill.transaction_at);

          return [
            pack_bill.id, pack_bill.user_name, pack_bill.user_email, pack_bill.user_phone,
            pack_bill.pack_type, pack_bill.pack_size, pack_bill.partner_status, transactionAt
          ];
        });

        csvGenerator('compras-de-adicionais.csv', [headers, ...rows]);

        toast.success('Arquivo CSV gerado com sucesso!');
      })
      .catch(err => {
        toast.error('Não foi possível gerar o arquivo CSV');
        console.error('[ERROR to generateCSV]', err);
      });
  }

  return (
    <div style={{justifyContent: 'center', alignItems: 'center', padding: 20}}>
      <PaperView
        Icon={ SupervisedUserCircle }
        iconColor="blue"
        title={'Assianturas'}
      >
        <>
          <StatusBilling
            csv={generateCSV}
            status={(status) => setStatus(status)}
            setStartDate={(date) => setDataInit(date)}
            setEndDate={(date) => setDataEnd(date)}
          />
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Usuário</TableCell>
                  <TableCell align="center">Email</TableCell>
                  <TableCell align="center">Telefone</TableCell>
                  <TableCell align="center">Tipo de adicional</TableCell>
                  <TableCell align="center">Licenças</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Data da transação</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                { loading &&
                  <TableRow key="loading">
                    <TableCell align="center" colSpan={7}>Carregando...</TableCell>
                  </TableRow>
                }
                { !loading && data.length === 0 &&
                  <TableRow key="empty">
                    <TableCell align="center" colSpan={7}>Nenhuma informação localizada</TableCell>
                  </TableRow>
                }
                { !loading && data.length > 0 && data.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell align="center">{row.user_name}</TableCell>
                    <TableCell align="center">{row.user_email}</TableCell>
                    <TableCell align="center">{row.user_phone}</TableCell>
                    <TableCell align="center">{row.pack_type ? TypeName[row.pack_type] : ''}</TableCell>
                    <TableCell align="center">{row.pack_size}</TableCell>
                    <TableCell align="center">{row.partner_status ? StatusName[row.partner_status] : ''}</TableCell>
                    <TableCell align="center">{moment(row.transaction_at).format('DD/MM/YYYY, h:mm:ss a')}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      </PaperView>
    </div>
  );
}

export default React.memo(PartnersDashboardsList);
